/**
 * @generated SignedSource<<b62f05313eca04e85e163366dae3e90b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleListContent$data = {
  readonly __typename: string;
  readonly entityId: string;
  readonly " $fragmentSpreads": FragmentRefs<"articleDividerArticle" | "articleFooterContent" | "articlePaginationCheckerContent" | "articlePaginationNavigationHistoryContent" | "articlePianoPaywallContent" | "articleRecommendationContent" | "articleRenderArticle" | "contextsArticleListContextProviderArticle" | "contextsContentReadMoreContextProviderContent" | "helpersCheckIsStyleArticle">;
  readonly " $fragmentType": "articleListContent";
};
export type articleListContent$key = {
  readonly " $data"?: articleListContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleListContent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v1 = [
  {
    "kind": "Variable",
    "name": "bodyType",
    "variableName": "bodyType"
  },
  {
    "kind": "Variable",
    "name": "customContents",
    "variableName": "customContents"
  }
],
v2 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": "PARAGRAPH",
      "kind": "LocalArgument",
      "name": "bodyType"
    },
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "customContents"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleListContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleDividerArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleFooterContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articlePaginationCheckerContent"
    },
    {
      "args": (v1/*: any*/),
      "kind": "FragmentSpread",
      "name": "articlePaginationNavigationHistoryContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articlePianoPaywallContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleRecommendationContent"
    },
    {
      "args": (v1/*: any*/),
      "kind": "FragmentSpread",
      "name": "articleRenderArticle"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "contextsArticleListContextProviderArticle",
      "selections": (v2/*: any*/),
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contextsContentReadMoreContextProviderContent"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersCheckIsStyleArticle",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SectionSegmentV2",
          "kind": "LinkedField",
          "name": "sectionsV2",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "value",
              "plural": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": (v2/*: any*/),
                  "type": "Section",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v2/*: any*/),
                  "type": "VideoSection",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};
})();

(node as any).hash = "7d78a90a2ab86616709e0af9ecef3437";

export default node;
